// extracted by mini-css-extract-plugin
export default {"greeting":"dashboard_greeting__bgpbV","bookingsTitle":"dashboard_bookingsTitle__4jVSg","exit":"dashboard_exit__vmE3G"};